var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTranscript({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E1BF48C4-6A7B-428F-BA66-CD89D5151985") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VertexAiPage",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VertexAILanding",
    transform: "translate(-529.000000, -460.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(87.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(36.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bubble-1",
    transform: "translate(0.000000, 221.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416,44 L406,44 L406,46 L416,46 L416,44 Z M422,36 L406,36 L406,38 L422,38 L422,36 Z M406,42 L422,42 L422,40 L406,40 L406,42 Z M406,32 L406,34 L422,34 L422,32 L406,32 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranscript);
export default __webpack_public_path__ + "static/media/transcript.be25711899dae3554715b252a8c3c1a8.svg";
export { ForwardRef as ReactComponent };